
import { Component, Vue } from 'nuxt-property-decorator'

@Component({ name: 'TrimmedLogo' })
export default class TrimmedLogo extends Vue {}
